<template>
  <div class="video-player">
    <div class="initial-wrapper" v-if="!isStarted" @click="play">
      <div class="initial-play">
        <span class="initial-play-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69L9.54 5.98A.998.998 0 0 0 8 6.82"/></svg>
        </span>
      </div>
    </div>

    <video ref="videoPlayer" @click="togglePlay" @timeupdate="timeUpdated" @loadeddata="initializeVideo" @ended="handleEnd" :poster="poster">
      <source :src="src" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    <template v-if="isStarted">
      <div class="controls">
        <button @click="togglePlay" class="play-pause">
          <svg v-if="!isPlaying" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#ffffff" d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69L9.54 5.98A.998.998 0 0 0 8 6.82"/></svg>
          
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#ffffff" d="M8 19c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2v10c0 1.1.9 2 2 2m6-12v10c0 1.1.9 2 2 2s2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2"/></svg>
        </button>
  
        <div class="video-player-controls-slider">
          <range-slider class="video-player-slider" min="0" max="100" :value="progress" @input="(value) => seek(value)"/> 
        </div>
        
        <div class="time">{{ currentTime }} / {{ duration }}</div>
  
        <button @click="toggleMute">
          <svg v-if="!isMuted" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#ffffff" d="M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1m13.5 2A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02M14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85"/></svg>

          <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#ffffff" d="M3.63 3.63a.996.996 0 0 0 0 1.41L7.29 8.7L7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91c-.36.15-.58.53-.58.92c0 .72.73 1.18 1.39.91c.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 1 0 1.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0M19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87c0-3.83-2.4-7.11-5.78-8.4c-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12m-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7M16.5 12A4.5 4.5 0 0 0 14 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24"/></svg>
        </button>

        <button @click="toggleFullScreen">
          <svg v-if="!isFullScreen" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#ffffff" d="M6 14c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1H7v-2c0-.55-.45-1-1-1m0-4c.55 0 1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1m11 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1zM14 6c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1"/></svg>

          <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#ffffff" d="M6 16h2v2c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1m2-8H6c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1zm7 11c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1m1-11V6c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1z"/></svg>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import RangeSlider from 'vue-range-slider';
import 'vue-range-slider/dist/vue-range-slider.css'

export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    onProgress: {
      type: Function,
    }
  },
  components: {
    RangeSlider,
  },
  data() {
    return {
      isStarted: false,
      isPlaying: false,
      isMuted: false,
      isFullScreen: false,
      progress: 0,
      currentTime: "0:00",
      duration: "0:00",
    };
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.fullscreenChanged);
  },
  destroyed() {
    document.removeEventListener('fullscreenchange', this.fullscreenChanged);
  },
  methods: {
    play(){
        this.$refs.videoPlayer.play();

        this.isPlaying = true;

        if(!this.isStarted) this.isStarted = true;
    },
    pause(){
        this.$refs.videoPlayer.pause();

        this.isPlaying = false;
    },
    togglePlay() {
      if (this.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    },
    timeUpdated() {
      this.updateProgress();
    },
    updateProgress() {
      const video = this.$refs.videoPlayer;

      if(video){
        this.progress = (video.currentTime / video.duration) * 100;
        this.currentTime = this.formatTime(video.currentTime);
      }
    },
    initializeVideo() {
      this.duration = this.formatTime(this.$refs.videoPlayer.duration);

      if(this.autoplay){
        this.play();
      }
    },
    seek(value) {
      const video = this.$refs.videoPlayer;
      const seekPosition = (Number(value) / 100) * video.duration;

      this.updateProgress();

      if (video.fastSeek) {
        video.fastSeek(seekPosition);
      } else {
        video.currentTime = seekPosition;
      }
    },
    handleEnd() {
      this.pause();
      this.progress = 100;
      this.currentTime = this.duration;
    },
    toggleMute() {
      this.$refs.videoPlayer.muted = !this.$refs.videoPlayer.muted;

      this.isMuted = this.$refs.videoPlayer.muted;
    },
    formatTime(timeInSeconds) {
      const minutes = Math.floor(timeInSeconds / 60);
      const seconds = Math.floor(timeInSeconds % 60);
      
      return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        this.$el.requestFullscreen().catch(err => {
          console.error(`Error attempting to enable fullscreen: ${err.message}`);
        });
      } else {
        document.exitFullscreen();
      }
    },
    fullscreenChanged() {
      this.isFullScreen = !!document.fullscreenElement;
    },
  },
  watch: {
    progress() {
      this.$emit("onProgress", {
        progress: parseInt(this.progress),
      })
    }
  }
};
</script>

<style scoped>
.video-player {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  isolation: isolate;
}

.video-player .initial-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.video-player .initial-wrapper .initial-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s ease;
}

.video-player .initial-wrapper .initial-play-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #111;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.video-player .initial-wrapper .initial-play-icon svg {
  width: 28px;
  height: 28px;
  margin-left: 4px;
}

.video-player .initial-wrapper .initial-play:hover .initial-play-icon {
  transform: scale(1.06);
  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.4);
}

.video-player .initial-wrapper .initial-play:active .initial-play-icon {
  transform: scale(0.97);
}

.video-player video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.video-player .controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  padding: 10px;
  transition: opacity 0.3s;
  transition-delay: 200ms;
  gap: 10px;
  opacity: 0;
  z-index: 2;
}

.video-player:hover .controls {
  opacity: 1;
}

.video-player button {
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
}

.video-player-controls-slider {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.video-player-slider {
  padding: 0;
  cursor: pointer;
  width: 100%;
}

.video-player-slider ::v-deep .range-slider-rail {
  background-color: rgba(255, 255, 255, 0.2);
}

.video-player-slider ::v-deep .range-slider-knob {
  display: none !important;
}

.video-player-slider ::v-deep .range-slider-fill {
  transition: width 0.1s;
  background-color: #4B60EB !important;
}

.video-player .time {
  flex-shrink: 0;
  color: #fff;
  font-size: 14px;
  text-align: right;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .video-player .controls {
    padding: 6px 8px;
    gap: 6px;
    flex-wrap: wrap;
  }

  .video-player .controls .play-pause {
    order: 1;
  }

  .video-player .time {
    order: 2;
    flex: 1;
    min-width: 0;
    font-size: 12px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .video-player .controls button:nth-child(4) {
    order: 3;
  }

  .video-player .controls button:nth-child(5) {
    order: 4;
  }

  .video-player-controls-slider {
    order: 5;
    flex-basis: 100%;
    margin-top: 4px;
  }

  .video-player button {
    padding: 4px;
  }

  .video-player button svg {
    width: 24px;
    height: 24px;
  }

  .video-player .initial-wrapper .initial-play,
  .video-player .initial-wrapper .initial-play-icon {
    width: 4rem;
    height: 4rem;
  }

  .video-player .initial-wrapper .initial-play-icon svg {
    width: 22px;
    height: 22px;
  }
}
</style>
